import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;

export type Platform = "app" | "web";

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}


export const useFetchCustomization = (platform: Platform) => {
  return useQuery({
    queryKey: ["product-customization", platform],
    queryFn: async () => {
      const res: ApiResponse = await fetch3(
        `${url}/api/marketplace?platform=${platform}`,
        "get"
      );

      if (!res || !res.success) {
        throw new Error(res?.message || "Failed to fetch customization");
      }

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useSaveCustomization = (platform: Platform) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/marketplace?platform=${platform}`,
        "PATCH",
        payload
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to save customization");
      }

      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["product-customization", platform],
      });
    },
  });
};


export const useDeleteCustomization = (platform: Platform) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res: ApiResponse = await fetch4(
        `${url}/api/marketplace?platform=${platform}`,
        "delete"
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to delete customization");
      }

      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["product-customization", platform],
      });
    },
  });
};